export const mail = {
    "mailLog": {
        "mailLog01": "Sent",
        "mailLog02": "Not sent",
        "mailLog03": "Log Date",
        "mailLog04": "From",
        "mailLog05": "To",
        "mailLog06": "Cc",
        "mailLog07": "Bcc",
        "mailLog08": "Status",
        "mailLog09": "Announcement Date"
    },
    "mailQueue": {
        "mailQueue01": "Sent",
        "mailQueue02": "Not sent",
        "mailQueue03": "From",
        "mailQueue04": "Subject",
        "mailQueue05": "Create Date",
        "mailQueue06": "Status",
        "mailQueue07": "Send Date",
        "mailQueue08": "Choose template...",
        "mailQueue09": "To",
        "mailQueue10": "Mail Subject",
        "mailQueue11": "Mail Content",
        "mailQueue12": "From Name",
        "mailQueue13": "From Email",
        "mailQueue14": "To Name",
        "mailQueue15": "To Email",
        "mailQueue16": "Mail Queue - Create",
        "mailQueue17": "Mail Queue - Update",
        "mailQueue18": "Mail Queue - View"
    },
    "mailRole": {
        "mailRole01": "Role Id",
        "mailRole02": "Role Name",
        "mailRole03": "Number of Accounts",
        "mailRole04": "Users",
        "mailRole05": "Mail Role - Create",
        "mailRole06": "Mail Role - Update"
    },
    "mailSet": {
        "mailSet01": "Template Name",
        "mailSet02": "Template Subject",
        "mailSet03": "Mail Template",
        "mailSet04": "Sender/Recipient",
        "mailSet05": "Template Id",
        "mailSet06": "Mail Subject",
        "mailSet07": "E-Mail",
        "mailSet08": "Mail Role",
        "mailSet09": "Mail Type",
        "mailSet10": "Mail To",
        "mailSet11": "Mail Address",
        "mailSet12": "Mail Title",
        "mailSet13": "Mail Content",
        "mailSet14": "Mail Set - Create",
        "mailSet15": "Mail Set - Update"
    }
}